import { render, staticRenderFns } from "./InsideProduct.vue?vue&type=template&id=31377262&scoped=true"
import script from "./InsideProduct.vue?vue&type=script&lang=js"
export * from "./InsideProduct.vue?vue&type=script&lang=js"
import style0 from "./InsideProduct.vue?vue&type=style&index=0&id=31377262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31377262",
  null
  
)

export default component.exports